<template>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
    v-model="dialog"
    width="90%"
  >
    <v-card>
      <v-col
        class="d-flex pa-0"
      >
        <v-btn
          icon
          color="grey darken-2"
          @click="dialog = false"
          class="pa-5"
          x-small
        >
          <v-icon
            class="close-hover"
            large
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
      <v-row class="ma-0">
        <component
          :is="name"
          :idProp="id"
          :accountProp="accountProp"
          :notStore="notStore"
          :typeProp="typeProp"
          @get="get"
          @close="dialog = false"
        />
      </v-row>
      <v-card-actions />
    </v-card>
  </v-dialog>
</template>

<script>
  import account from '../../../pages/account/customer'
  import product from '../../../pages/product/product'
  import productTurnover from '../../../pages/product/turnover'
  import accountingPrint from '../../../pages/accounting/print'
  import accountingTurnover from '../../../pages/accounting/turnover'
  import payment from '../../../pages/treasury/payments'
  import check from '../../../pages/treasury/check'
  import task from '../../../pages/task/task'
  export default {
    name: 'Index',
    components: {
      productTurnover,
      accountingTurnover,
      product,
      check,
      task,
      payment,
      account,
      accountingPrint,
    },
    props: ['dialogProp', 'dataProp'],
    data: () => ({
      dialog: false,
      name: null,
      accountProp: null,
      notStore: null,
      typeProp: null,
      id: null,
    }),
    computed: {
      components: {
        get () {
          return this.$store.state.components
        },
        set (val) {
          this.$store.commit('SET_COMPONENTS', val)
        },
      },
    },
    watch: {
      components () {
      },
      dialog () {
        if (!this.dialog) {
          this.$emit('close')
        }
      },
      dialogProp () {
        if (this.dialogProp) {
          this.dialog = true
        }
      },
      dataProp () {
        if (this.dataProp) {
          this.open(this.dataProp)
        }
      },
    },
    mounted () {
      if (this.dialogProp) {
        this.dialog = true
      }
      if (this.dataProp) {
        this.open(this.dataProp)
      }
    },
    methods: {
      get (data) {
        this.$emit('get', data)
      },
      open (item) {
        this.id = item.id
        this.name = item.name
        this.accountProp = item.accountProp
        this.notStore = item.notStore
        this.typeProp = item.type
      },
    },
  }
</script>

<style scoped>

</style>
